'use client';

import { FC } from 'react';

import { ProductCard } from '@/general/components/ProductCard/ProductCard';
import { BaseCarData } from '@/types/Car.types';
import { pushToDataLayerProductCard } from '@/utils/pushToDataLayerProductCard';

const getCarTileTestId = (carouselName?: string, index?: number) => {
  if (carouselName === 'new-cars-every-day') {
    return `new-cars-car-${index}`;
  }
  return undefined;
};

const getImageTestId = (carouselName?: string) => {
  if (carouselName === 'size-carousel') {
    return 'size-carousel-images';
  }
  return undefined;
};

type Props = {
  carData: BaseCarData;
  weeklyRepayment: number;
  defaultRate: number;
  index: number;
  carouselName?: string;
  carouselValue?: string;
};

export const VehicleCarouselTile: FC<Props> = ({
  carData,
  weeklyRepayment,
  defaultRate,
  index,
  carouselName,
  carouselValue,
}) => {
  return (
    <div data-testid={getCarTileTestId(carouselName, index)}>
      <ProductCard
        carData={carData}
        weeklyRepayment={weeklyRepayment}
        defaultRate={defaultRate}
        variant="default"
        imageTestId={getImageTestId(carouselName)}
        onCardClick={
          carouselName && carouselValue
            ? () => {
                pushToDataLayerProductCard(carData, index, {
                  event: 'carousel_tile_click',
                  name: carouselName,
                  value: carouselValue,
                });
              }
            : undefined
        }
      />
    </div>
  );
};
